module.exports = __webpack_public_path__ + "static/media/insect.35c86612.jpg";